import { create } from 'zustand'

interface SoftPhone {
  busyType: string
  busyDesc: string
  stateTimer: string
  busyTypeOptions: string[]
  extenType: string
  answerWay: { id: string; label: string }[]
}

interface SoftPhoneStore {
  softPhone: SoftPhone
  softPhoneBarVisible: boolean
  // panelTimerVisible: boolean
  stateTimer: string // 状态栏时间
  updateTimer: (value) => unknown
  updateSoftPhone: (softPhone) => void
  updateStoreAttr: (key, value) => unknown
  updateSoftPhoneAttr: (key, value) => unknown
  setSoftPhoneBarVisible: (visible) => unknown // 状态栏显示更新
}

const useSoftPhoneStore = create<SoftPhoneStore>(set => ({
  // bears: 0,
  // increasePopulation: () => set(state => ({ bears: state.bears + 1 })),
  // removeAllBears: () => set({ bears: 0 }),
  stateTimer: '00:00:00',
  softPhoneBarVisible: false,
  // panelTimerVisible: false,
  softPhone: {
    extenType: 'gateway',
    answerWay: [
      { id: 'gateway', label: '网关方式' },
      { id: 'Local', label: '直线接听' },
    ],
  } as SoftPhone,
  updateSoftPhone: softPhone => set({ softPhone: { ...softPhone } }),
  updateTimer: stateTimer => set({ stateTimer }),
  setSoftPhoneBarVisible: softPhoneBarVisible => set({ softPhoneBarVisible }),
  updateStoreAttr: (key, value) => state => set({ ...state, [key]: value }),
  updateSoftPhoneAttr: (key, value) =>
    set(state => {
      const softPhone = { ...state.softPhone, [key]: value }
      return { softPhone }
    }),
}))

export default useSoftPhoneStore
